
<script>
import { apiORDS, apiORDSpost, urlORDS, apiORDSmidia, apiDateORDS } from '../shared/api-functions'
import { getText, formatDate, formatValue, formatDateTraco } from '../shared/utils'
import { SysVars } from '../main';
import tableGrid from '../components/tableGrid'
export default {
  data() {
    return {
      tprel: {
        "fieldname": "rel", "label": "Tipo de Relatório",
        "length": 1, "decimals": 0, "pk": "False",
        "options": [{ "id": "P", "text": "Pedidos" }, { "id": "N", "text": "Notas Fiscais" },
        { "id": "T", "text": "Produtos Vendidos" }]
      },
      rel: null,
      tppedvfil: {
        "fieldname": "tppedv", "label": "Tipo de Pedido",
        "length": 1, "decimals": 0, "pk": "False",
        "options": [{ "id": "T", "text": "Todos" }, { "id": "VENDA", "text": "Pedidos" }, { "id": "ORCAMENTO", "text": "Orçamentos" },
        { "id": "PERDIDO", "text": "Orçamentos Perdidos" }]
      },
      tppedv: 'T',
      stpedvfil: {
        "fieldname": "tppedv", "label": "Status do Pedido",
        "length": 1, "decimals": 0, "pk": "False",
        "options": [{ "id": "T", "text": "Todos" }, { "id": "F", "text": "Faturado" }, { "id": "P", "text": "Pendente" },
        { "id": "D", "text": "Em Digitação" }, { "id": "A", "text": "Em Aprovação" }, { "id": "R", "text": "Rejeitado" },
        { "id": "S", "text": "Saldo Cancelado" },
        { "id": "C", "text": "Cancelado" }]
      },
      stpedv: 'T',
      operacaonffil: {
        "fieldname": "operacaonf", "label": "Tipo de Nota",
        "length": 1, "decimals": 0, "pk": "False",
        "options": [{ "id": "S", "text": "Saída" }, { "id": "E", "text": "Entrada" }]
      },
      operacaonf: 'S',
      image: null,
      columns: [],
      stnf: [],
      cliente: '',
      filial: '',
      filialLogo: '',
      textQuery: '',
      metadata: this.$store.getters.getEntities.metadata,
      filter: {            //objeto utilizado pelo filtro de mes
        startDate: null,
        endDate: null,
        codusuario: null,
      },
      currentPage: 1,
      sendData: {},
      gruest: '',
      gruestid: '',
      part: '',
      campo1: '',
      campo2: '',
      campo3: '',
      campo4: '',
    }
  },
  computed: {
    list: function () {
      if (this.rel === 'P') {
        return this.$store.getters.getPedvList
      } else if (this.rel === 'N') {
        return this.$store.getters.getNfList
      } else if (this.rel === 'T') {
        return this.$store.getters.getTeste
      }
    },

  },
  filters: {
  },
  methods: {
    async loadData() {
      var str = '';
      let param = {};
      param.query = '';

      if (this.textQuery) {
        param.query = param.query + this.textQuery
      }

      if (this.rel === 'P') {
        this.$store.dispatch('loadPedvList', param)
      } else if (this.rel === 'N') {
        this.$store.dispatch('loadListNf', param)
      } else if (this.rel === 'T') {
        this.$store.dispatch('loadTeste', this.sendData)
      }

      this.loadLogotipo();
      (this.currentPage === 1) ? this.currentPage = 0 : this.currentPage = 1;
    },
    formatar(value, tipo) {
      if (tipo == 'D') { // Data
        return formatDate(value)
      } else if (tipo == 'N') {
        return formatValue(value, 2)
      } else {
        return value
      }
    },
    filtrosRel() {
      this.campo1 = '';
      this.campo2 = '';
      this.campo3 = '';
      this.campo4 = '';

      if (this.part && this.part.length > 0) {
        this.campo1 = 'Cliente: ' + this.part[0].nome;
      }

      if (this.rel === 'P') {
        this.campo2 = 'Tipo de Pedido: ' + this.tppedvfil.options.find(a => a.id === this.tppedv).text;
        this.campo3 = 'Situação do Pedido: ' + this.stpedvfil.options.find(a => a.id === this.stpedv).text;
      } else if (this.rel === 'N') {
        this.campo2 = 'Tipo de Nota: ' + this.operacaonffil.options.find(a => a.id === this.operacaonf).text;
        this.campo3 = 'Situação das Notas: ';
        for (var x = 0; x < this.stnf.length; x++) {
          if (this.stnf[x].filtrar === true) {
            this.campo3 = this.campo3 + this.stnf[x].label + ' | ';
          }
        }
      } else if (this.rel === 'T') {
        if (this.gruest) {
          this.campo2 = 'Grupo de Estoque: ' + this.gruest.descricao;
        }
      }
    },
    async textSearch(value) {
      //efetua a pesquisa por texto
      await this.loadPart();
      await this.loadGruEst();
      this.filtrosRel();
      let str = '';

      if (this.rel === 'T') {
        this.sendData = {};
        if (this.cliente && this.cliente != null && this.cliente != '') {
          str = '';
          str = this.cliente.toUpperCase();
          this.sendData.clientes = [];
          this.sendData.clientes.push(str);
        }
        if (this.filial != '') {
          str = '';
          str = this.filial.toUpperCase();
          this.sendData.filiais = [];
          this.sendData.filiais.push(str);
        }

        if (this.filter.startDate != null) {
          str = '';
          str = formatDateTraco(this.filter.startDate);
          this.sendData.after = str;
        }
        if (this.filter.endDate != null) {
          str = '';
          str = formatDateTraco(this.filter.endDate);
          this.sendData.before = str;
        }
        if ((this.gruestid) && (this.gruestid != '')) {
          str = '';
          str = this.gruestid.toUpperCase();
          this.sendData.gruest = [];
          this.sendData.gruest.push(str);
        }
      } else {
        // this.filter = '{"$or":[{"nome":{"$like":"%25' + str + '%25"}},{"npedido":{"$like":"%25' + str + '%25"}}]}'
        if ((this.rel === 'N') && (this.cliente && this.cliente != null && this.cliente != '')) {
          str = '';
          str = this.cliente.toUpperCase();
        }
        this.textQuery = 'text=' + str;

        if (this.filial != '') {
          str = '';
          str = this.filial.toUpperCase();
          this.textQuery = this.textQuery + '&filial=' + str;
        }

        if (this.filter.startDate != null) {
          str = '';
          str = apiDateORDS(this.filter.startDate);
          this.textQuery = this.textQuery + '&after=' + str;
        }
        if (this.filter.endDate != null) {
          str = '';
          str = apiDateORDS(this.filter.endDate, true);
          this.textQuery = this.textQuery + '&before=' + str;
        }

        if (this.rel === 'P') {
          if (this.tppedv != 'T') {
            str = '';
            str = this.tppedv.toUpperCase();
            this.textQuery = this.textQuery + '&status=' + str;
          }

          if (this.stpedv != 'T') {
            str = '';
            str = this.stpedv.toUpperCase();
            this.textQuery = this.textQuery + '&stpedv=' + str;
          }

          if (this.cliente && this.cliente != null && this.cliente != '') {
            str = '';
            str = this.cliente.toUpperCase();
            this.textQuery = this.textQuery + '&codpart=' + str;
          }
        } else if (this.rel === 'N') {
          str = '';
          str = this.operacaonf.toUpperCase();
          this.textQuery = this.textQuery + '&operacaonf=' + str;

          str = '';
          str = '%5B99';
          for (var x = 0; x < this.stnf.length; x++) {
            if (this.stnf[x].filtrar === true) {
              str = str + '%2C' + this.stnf[x].id;
            }
          }
          console.log(str)
          this.textQuery = this.textQuery + '&stnf=' + str + '%5D';

        }
      }

      this.loadData()

    },
    async loadLogotipo() {
      let self = this;
      self.filialLogo = null;
      self.image = null;
      if (self.filial != '') {
        await self.$store.dispatch('loadFilial', { id: self.filial })
        if (self.$store.getters.getFilial) {
          self.filialLogo = { ...self.$store.getters.getFilial }

          if (self.filialLogo.logotipo[0]) {
            self.image = self.filialLogo.logotipo[0].content;
          }

        }
      }
    },
    async loadPart() {
      let self = this;
      self.part = null;
      if (self.cliente != '') {
        await self.$store.dispatch('loadPart', { id: self.cliente })
        if (self.$store.getters.getPart) {
          self.part = { ...self.$store.getters.getPart }
        }
      }
    },
    async loadGruEst() {
      let self = this;
      self.gruest = null;
      if ((self.gruestid) && (self.gruestid != '')) {
        await self.$store.dispatch('loadGruest', { id: self.gruestid })
        if (self.$store.getters.getGruest) {
          self.gruest = { ...self.$store.getters.getGruest }
        }
      }
    },
    downloadTest() {
      let somaMer = 0
      let somaDesc = 0
      let somaGer = 0
      let somaDesp = 0
      let self = this
      function formatar(value, tipo) {
        if (tipo == 'D') { // Data
          return formatDate(value)
        } else if (tipo == 'N') {
          return formatValue(value, 2)
        } else {
          return value
        }
      }

      function cabecalho() {
        if (self.image != null) {
          return {
            margin: [0, 0, 0, 10],
            table: {
              widths: [100, '*'],
              body: [
                [
                  { image: 'data:image/png;base64,' + self.image, border: [false, false, false, false], width: 98 },
                  {
                    border: [true, false, false, false],
                    table: {
                      body: [
                        [{ text: self.filialLogo.nome, border: [false, false, false, false], fontSize: 20, bold: true }],
                        [{ text: 'Relatório emitido em: ' + formatar(self.$getDate(), 'D'), border: [false, false, false, false] }],
                        [{ text: self.campo1, border: [false, false, false, false] }],
                        [{ text: self.campo2, border: [false, false, false, false] }],
                        [{ text: self.campo3, border: [false, false, false, false] }],
                        [{ text: self.campo4, border: [false, false, false, false] }],
                      ]
                    },
                  }
                ]
              ]
            }
          }
        } else {
          return {
            margin: [0, 0, 0, 10],
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    border: [true, false, false, false],
                    table: {
                      body: [
                        [{ text: ((self.filialLogo != null) ? self.filialLogo.nome : ''), border: [false, false, false, false], fontSize: 20, bold: true }],
                        [{ text: 'Relatório emitido em: ' + formatar(self.$getDate(), 'D'), border: [false, false, false, false] }],
                        [{ text: self.campo1, border: [false, false, false, false] }],
                        [{ text: self.campo2, border: [false, false, false, false] }],
                        [{ text: self.campo3, border: [false, false, false, false] }],
                        [{ text: self.campo4, border: [false, false, false, false] }],
                      ]
                    },
                  }
                ]
              ]
            }
          }
        }
      }

      Object.byString = function (o, s, f) {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        var a = s.split('.');
        for (var i = 0, n = a.length; i < n; ++i) {
          var k = a[i];

          if (k in o) {
            o = formatar(o[k], f);
            //somaMer += o[k]
          } else {
            return;
          }
        }
        return o;
      }
      function buildTableBody(data, columns, showHeaders, headers, fontSize, formatacao, totaliza) {
        var body = [];
        var self = this;
        var valorTotal = [];
        var dataRow = [];
        var i = 0;
        // Inserting headers
        if (showHeaders) {
          body.push(headers);
        }
        columns.forEach(function (column) {
          if ((totaliza[i]) && (formatacao[i] === 'N')) {
            valorTotal[i] = 0;
          } else {
            valorTotal[i] = '';
          }
          i++;
        });

        // Inserting items from external data array
        data.forEach(function (row) {
          dataRow = [];
          i = 0;
          columns.forEach(function (column) {
            dataRow.push({
              text: Object.byString(row, column, formatacao[i]), alignment: headers[i].alignment,
              fontSize: fontSize
            });
            if ((totaliza[i]) && (formatacao[i] === 'N')) {
              valorTotal[i] += row[column];
            }
            i++;
          })

          body.push(dataRow);
        });
        // Totalização
        dataRow = [];
        i = 0;

        columns.forEach(function (column) {
          dataRow.push({
            text: (totaliza[i]) ? formatar(valorTotal[i], formatacao[i]) : '', alignment: headers[i].alignment,
            fontSize: (fontSize + 1), bold: true
          });
          i++;
        })
        body.push(dataRow);

        return body;
      }

      function table(data, columns, witdhsDef, showHeaders, headers, layoutDef, fontSize, formatacao, totaliza) {
        return {
          table: {
            headerRows: 1,
            widths: witdhsDef,
            body: buildTableBody(data, columns, showHeaders, headerTable(headers), fontSize, formatacao, totaliza)
          },
          layout: layoutDef
        };
      }

      function headerTable(data) {
        var dataRow = [];
        data.forEach(function (row) {
          if (row[4] == true) {
            dataRow.push({ text: row[1], style: 'tableHeader', alignment: row[5] });
          }
        });
        return dataRow
      }
      function colunas(data, i) {
        var dataRow = [];
        data.forEach(function (row) {
          if (row[4] == true) {
            dataRow.push(row[i]);
          }
        });
        return dataRow
      }

      if (this.list.length > 0) {
        const docDefinition = {

          pageOrientation: (this.rel === 'N') ? 'landscape' : 'portrait',

          // Informações do PDF
          info: {
            title: this.tprel.options.find(a => a.id === this.rel).text,
            author: 'Nota Brasil'
          },

          content: [
            // Cabeçalho
            cabecalho(),

            // Fim Cabeçalho
            {
              margin: 10,
              text: this.tprel.options.find(a => a.id === this.rel).text,
              fontSize: 20,
              bold: true,
              alignment: 'center'
            },
            // Tabela
            table(
              // External data
              this.list,
              // Columns display order
              colunas(this.columns, 0),
              // Custom columns widths
              colunas(this.columns, 6),
              // Show headers?
              true,
              // Custom headers
              this.columns,
              // Custom layout, use '' for no layout
              'lightHorizontalLines',
              9,
              colunas(this.columns, 3),
              colunas(this.columns, 7)),

            // Totalização
            /*
            {
                margin: 50,
                aligment: 'center',
                table: {
                    widths: ['*','*','*', '*'],
                    alignment: 'center',
                    body: [
                        [
                            {text: 'Total Bruto', bold: true, alignment: 'right'},
                            {text: 'Total de Desconto', bold: true, alignment: 'right'},
                            {text: 'Total de Despesas', bold: true, alignment: 'right'},
                            {text: 'Total Líquido', bold: true, alignment: 'right'}
                        ],
                        [
                            {text: formatar(somaMer, 'N'), bold: true, alignment: 'right'},
                            {text: formatar(somaDesc, 'N'), bold: true, alignment: 'right'},
                            {text: formatar(somaDesp, 'N'), bold: true, alignment: 'right'},
                            {text: formatar(somaGer, 'N'), bold: true, alignment: 'right'}
                        ],
                    ]
                }
            }
            */
            // Fim Totalização
          ],

          // Paginação
          footer:
            function (currentPage, pageCount) {
              return {
                margin: 10,
                columns: [
                  {
                    fontSize: 9,
                    text: [
                      currentPage.toString() + ' de ' + pageCount
                    ],
                    alignment: 'center'
                  }
                ]
              };
            },
          // Fim Paginação

          styles: {
            tableRow: {
              fontSize: 10,
              alignment: 'center'
            },
            tableHeader: {
              alignment: 'center',
              bold: true,
              fontSize: 9,
              color: 'black',
              borders: [false, false, true, false]
            }
          },
        };

        pdfMake.createPdf(docDefinition).open();
      }
    },
  },
  components: {
    tableGrid
  },
  watch: {
    rel: function () {
      (this.currentPage === 1) ? this.currentPage = 0 : this.currentPage = 1;
      /*
      [
          0 = 'Campo',
          1 = 'Descrição do Cabeçalho',
          2 = 'Percentual da Coluna na Grade',
          3 = 'Formatar: D - Data / N - Decimal,
          4 = 'Exibir Coluna: true / false,
          5 = 'Alinhamento: center / left / right,
          6 = 'Tamanho da Coluna no Relatório',
          7 = 'Totaliza',
          8 = 'Valor total'
      ]
      */
      if (this.rel === 'P') {

        this.columns = [
          ['npedido', 'Pedido', '5%', '', true, 'left', '*', false, 0],
          ['ncotacao', 'Orçamento', '5%', '', true, 'left', '*', false, 0],
          ['nome', 'Cliente', '60%', '', true, 'left', 150, false, 0],
          ['data', 'Data', '10%', 'D', true, 'center', '*', false, 0],
          ['totmer', 'Mercadorias', '5%', 'N', true, 'right', '*', true, 0],
          ['totaldesp', 'Impostos/Acréscimos', '5%', 'N', true, 'right', '*', true, 0],
          ['vlrdesc', 'Descontos', '5%', 'N', true, 'right', '*', true, 0],
          ['totger', 'Totais', '5%', 'N', true, 'right', '*', true, 0]];
      } else if (this.rel === 'N') {
        this.columns = [
          ['serie', 'Série', '5%', '', true, 'center', '*', false, 0],
          ['nf', 'Nr. NF', '5%', '', true, 'center', '*', false, 0],
          ['status', 'Status', '15%', '', true, 'left', 50, false, 0],
          ['nome', 'Cliente', '35%', '', true, 'left', 100, false, 0],
          ['data', 'Data', '10%', 'D', true, 'center', '*', false, 0],
          ['dtsai', 'Data de Saída', '10%', 'D', true, 'center', '*', false, 0],
          ['totmer', 'Mercadorias', '5%', 'N', true, 'right', '*', true, 0],
          ['totaldesp', 'Impostos/Acréscimos', '5%', 'N', true, 'right', '*', true, 0],
          ['vlrdesc', 'Descontos', '5%', 'N', true, 'right', '*', true, 0],
          ['totger', 'Totais', '5%', 'N', true, 'right', '*', true, 0]];

        this.stnf = [
          { "id": "10", "label": "Faturadas", "filtrar": true },
          { "id": "90%2C92", "label": "Canceladas", "filtrar": true },
          { "id": "01%2C02%2C11%2C50", "label": "Abertas", "filtrar": true },
          { "id": "00", "label": "Em Digitação", "filtrar": true }
        ];
      } else if (this.rel === 'T') {
        this.columns = [
          ['coditem', 'Código do Item', '5%', '', true, 'center', '*', false, 0],
          ['descricao', 'Item', '50%', '', true, 'left', 150, false, 0],
          ['uni', 'Uni', '5%', '', true, 'center', '*', false, 0],
          ['qt', 'Quantidade', '15%', 'N', true, 'right', '*', true, 0],
          ['total', 'Total', '15%', 'N', true, 'right', '*', true, 0]
          //,['percentual', 'Percentual', '10%', 'N', true, 'right', '*', true, 0]
        ];
      }
      this.textSearch();
    },
  },
  created() {
    this.rel = "P";
    //this.loadData()
  }
}
</script>

<template>
  <div class="default-container">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="grid">

            <div class="grid-item col-md-12 mb-4">
              <div class="card">
                <div class="card-header">
                  Filtros de Relatório
                </div>
                <div class="card-body">
                  <form-field v-model="rel" type="select" col="5" :metadata="tprel" :optionnull="true"></form-field>
                  <form-field v-model="tppedv" type="select" col="5" :metadata="tppedvfil" :optionnull="true"
                    v-show="rel === 'P'"></form-field>
                  <form-field v-model="stpedv" type="select" col="5" :metadata="stpedvfil" :optionnull="true"
                    v-show="rel === 'P'"></form-field>
                  <form-field v-model="operacaonf" type="select" col="5" :metadata="operacaonffil" :optionnull="true"
                    v-show="rel === 'N'"></form-field>
                  <!-- <form-field v-model=filial type="select2" col="12" name="filial"
                                        :select2="{entity: 'filial/',  minlength: 0}" label="Filial"></form-field> -->
                  <form-field v-model=cliente type="select2" col="12" name="cliente"
                    :select2="{ entity: 'cliente/', minlength: 0 }" label="Cliente"></form-field>
                  <form-field v-model=gruestid type="select2" col="12" name="Grupo de Estoque"
                    :select2="{ entity: 'gruest/', minlength: 0 }" label="Grupo de Estoque" v-show="rel === 'T'">
                  </form-field>
                  <div v-show="rel === 'N'">
                    <div class="col-sm-2">Situação das Notas:
                    </div>
                    <div class="col-md-auto">
                      <div class="form-check form-check-inline" v-for="(column, idx) in stnf" :key="idx">
                        <input v-model=column.filtrar class="form-check-input" type="checkbox" id="idx" value="option1">
                        <label class="form-check-label" for="inlineCheckbox1">{{ column.label }}</label>
                      </div>
                    </div>
                  </div>
                  <br>
                  <div class="col-sm-6">
                    <input-month2 :p-month="filter"></input-month2>
                  </div>
                  <br>
                  <button type="button" class="btn btn-primary" @click="this.textSearch">Consultar</button>

                </div>
                <div class="card-footer">
                  <div class="col-sm-2">Colunas:
                  </div>
                  <div class="col-sm-11">
                    <div class="form-check form-check-inline" v-for="(column, idx) in columns" :key="idx">
                      <input v-model=column[4] class="form-check-input" type="checkbox" id="idx" value="option1">
                      <label class="form-check-label" for="inlineCheckbox1">{{ column[1] }}</label>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="col-sm-2">Totalizar:
                  </div>
                  <div class="col-sm-11">
                    <div class="form-check form-check-inline" v-for="(column, idx) in columns" :key="idx"
                      v-show="column[3] === 'N'">
                      <input v-model=column[7] class="form-check-input" type="checkbox" id="idx" value="option1">
                      <label class="form-check-label" for="inlineCheckbox1">{{ column[1] }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="grid-item col-md-12 mb-4">
              <button type="button" class="btn btn-primary" @click="this.downloadTest">Imprimir</button>
            </div>

            <div class="grid-item col-md-12 mb-4">
              <tableGrid :campos=list :columns=columns :currentPage=currentPage>
              </tableGrid>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/print-form.vue